const sitePrefix = (path: string) => {
  const [locale, countryCode] = document.documentElement.lang.split('_');
  return locale === 'fr' && countryCode === 'FR' ? path : `/${locale}_${countryCode}${path}`;
}

export default {
  shopping_process_shipping: {
    fetch: '/checkout/shipping/_api',
    snapshot_withdrawal_points: '/checkout/shipping/_snapshot-withdrawal-points'
  },

  best_offer_list: {
    fetch: sitePrefix('/best-offer/_list'),
  }
}

